import { createAction, props } from '@ngrx/store';
import { AppMetrica } from 'src/app/models/android-app-model';


export const cargaMetricasApps= createAction(
  '[METRICAPPS] Carga',
  props<{ metricapps: AppMetrica[] }>()
  );
export const limpiaMetricasApps = createAction('[METRICAPPS] Remueve');
